import { Trans } from "react-i18next";
import { formatDate } from "services/util";
import { Link } from "react-router-dom";

export const renderModelNames = (name) => {
  const customNames = {
    "Access Accounts": "Accounting",
    "Prepare/Approve sales invoice": "Accounting",
    "Access Bank Accounts": "Accounting",
    "Access Sales": "Accounting",
    "Access Purchases": "Accounting",
    "Access Quotes": "Accounting",
    "Access Bills": "Accounting",
    "Record received payment": "Accounting",
    "Record/Approve bills to pay": "Accounting",
    "Prepare purchase order": "Accounting",
    "Access Inventory": "Accounting",
    "Add/Archive products items": "Accounting",
    "Access Chart of Accounts": "Accounting",
    "Access Contacts": "Accounting",
    "Add/Archive contacts": "Accounting",
    "Access Xero Settings": "Accounting",
    // "Access Reports": "Accounting",
    "Prepare/approve/edit Manual journal": "Accounting",
    "Payroll & HR": "HR Payroll",
    "Access Payruns": "HR Payroll",
    "Access Loans": "HR Payroll",
    "Access Time Off": "HR Payroll",
    "Access HR Settings": "HR Payroll",
    "Access Xero Account Dashboard": "Accounting",
    "Access HR & Payroll Dashboard": "HR Payroll",
    "Balance Sheet Report": "Accounting",
    "Bank Summary Report": "Accounting",
    "Budget Summary Report": "Accounting",
    "Executive Summary Report": "Accounting",
    "Payable Receivable Report": "Accounting",
    "Profit and Loss Report": "Accounting",
    "Trial Balance Report": "Accounting",
    "Trial Balance (Movement) Report": "Accounting",
    "Sales Tax Report": "Accounting",
    "Zatca Tax Report": "Accounting",
    "Expenses Report": "Accounting",
    "Payroll Payment Report": "Accounting",
    "Access Audit Report": "Audit Reports",
    "View Inventory Cost": "Accounting",
  };

  return customNames[name] || name;
};

export const getGroupCodenames = (group) => {
  const groupCodenamesMap = {
    2: ["xero_sales_edit", "xero_accounts", "xero_sales", "xero_purchases-orders_edit", "xero_purchases_edit", "xero_payments", "xero_purchases", 'xero_balance_sheet', 'xero_bank_summary', 'xero_budget_summary', 'xero_executive_summary', 'xero_payable_receivable', 'xero_profit_and_loss', 'xero_trial_balance', 'xero_trial_balance_movement', 'xero_sales_tax', 'zatca_tax_report', 'expense_report', 'payroll_payment_report', "xero_quotes", "xero_chart-of-accounts", "xero_manual-journal_edit"],
    3: ["xero_payments", "xero_items_edit", "xero_accounts_edit", "xero_accounts"],
    4: ["xero_accounts_edit", "xero_sales", "xero_contacts", "xero_accounts"],
    5: ["xero_accounts_edit", "xero_settings", "xero_contacts", "xero_chart-of-accounts"],
    6: ["hr_timeoff", "hr_payruns", "hr_payroll", "hr_loans", "hr_settings"],
    7: ["hr_timeoff", "hr_payruns"],
    8: ["access_audit_report"],
  };

  return groupCodenamesMap[group] || [];
};

export const accountTypes = [

  { Code: 'CURRENT', Name: 'Current Asset account' },
  { Code: 'CURRLIAB', Name: 'Current Liability account' },
  { Code: 'DEPRECIATN', Name: 'Depreciation account' },
  { Code: 'DIRECTCOSTS', Name: 'Direct Costs account' },
  { Code: 'EQUITY', Name: 'Equity account' },
  { Code: 'EXPENSE', Name: 'Expense account' },
  { Code: 'FIXED', Name: 'Fixed Asset account' },
  { Code: 'INVENTORY', Name: 'Inventory Asset account' },
  { Code: 'LIABILITY', Name: 'Liability account' },
  { Code: 'NONCURRENT', Name: 'Non-current Asset account' },
  { Code: 'OTHERINCOME', Name: 'Other Income account' },
  { Code: 'OVERHEADS', Name: 'Overhead account' },
  { Code: 'PREPAYMENT', Name: 'Prepayment account' },
  { Code: 'REVENUE', Name: 'Revenue account' },
  { Code: 'SALES', Name: 'Sales account' },
  { Code: 'TERMLIAB', Name: 'Non-current Liability account' },
];

export const commonNotes = [
  <Trans>1. Do not change the column headings provided in the template.</Trans>,
  <Trans>2. The fields marked with '*' are required and must be filled.</Trans>,
];

const dateNotes = [
  <Trans>3. Dates must be in the format 'YYYY-MM-DD' (i.e : 2024-12-25); any other format will result in an error.</Trans>,
]

const itemNotes = [
  <Trans>4. At least one of these fields is required (ItemCode or Description).</Trans>,
];

const visitHere = <>Include TaxCodes/TaxType and AccountCodes specific to your organization and for help regarding codes, visit <Link to='/codes'>here</Link>.</>

export const coaNotes = [
  ...commonNotes,
  <Trans>3. Ensure that Account Code and Account Name are unique for every entry, otherwise, it will result in an error.</Trans>,
  <Trans>4. A maximum of 20 accounts may be added in one Excel file for a smoother experience with Xero connection.</Trans>,
  <Trans>5. The Account Type cannot be 'BANK,' it must be of a specific type, the accepted list can be found <Link to='/codes'>here</Link>.</Trans>,
];

export const faNotes = [
  ...commonNotes,
  <Trans>3. Ensure Account Code and Account Name are unique for every entry, otherwise, it will result in an error.</Trans>,
  <Trans>4. A maximum of 20 accounts may be added in one Excel file for a smoother experience with Xero connection.</Trans>,
  <Trans>5. The Account Type cannot be 'BANK,' it must be of a specific type, the accepted list can be found <Link to='/codes'>here</Link>.</Trans>,
];

export const invNotes = [
  ...commonNotes,
  ...dateNotes,
  ...itemNotes,
  <Trans>5. The Invoice status cannot be paid at the start; hence it will be 'AUTHORISED', payment must be added later.</Trans>,
  <Trans>6. InvoiceNumber isn't required, keep it as empty or INV-AUTO for Automated Invoice numbers.</Trans>,
  <Trans>7. {visitHere}</Trans>,
];

export const billsNotes = [
  ...commonNotes,
  ...dateNotes,
  ...itemNotes,
  <Trans>5. The Bill status cannot be paid at the start; hence it will be 'AUTHORISED', payment must be added later.</Trans>,
  <Trans>6. {visitHere}</Trans>,
];

export const employeeNotes = [
  ...commonNotes,
  ...dateNotes
];

export const loansNotes = [
  ...commonNotes,
  ...dateNotes,
  <Trans>4. The Status of the loan should either be 'Running,' 'Pending' or 'Closed.'</Trans>,
  <Trans>5. Remaining Amount will be set to 0 for Loans with status 'Closed'.</Trans>,
  <Trans>6. The EmployeeName is not mandatory and could be blank.</Trans>,
];

export const contractNotes = [
  ...commonNotes,
  ...dateNotes,
  <Trans>4. If a contract already exist for an employee then it will be updated.</Trans>,
  <Trans>5. Status options can be "pending_approval" or "active"</Trans>,
  <Trans>6. Employee IDs can be found on employees export</Trans>,
];

export const itemsNotes = [
  ...commonNotes,
  <Trans>3. All fields are allowed to be empty except for ItemCode. If ItemCode is empty, the submission will be ignored.</Trans>,
  <Trans>4. The import limit per file is 500, but for optimal performance, it is recommended to keep the file around 100 items.</Trans>,
  <Trans>5. Each item can have either a buying price, a selling price, or both.</Trans>,
];

export const mjNotes = [
  ...commonNotes,
  ...dateNotes,
  <Trans>4. System Accounts (Receivable, Payable, and Retained), and Bank Account Codes are not allowed for Manual Journal.</Trans>,
  <Trans>5. Only two statuses, 'DRAFT' or 'POSTED,' are allowed. If a line does not have any status, it will default to 'DRAFT.'</Trans>,
  <Trans>6. As common for Manual Journal entries, the DebitAmount and CreditAmount should match for a successful post.</Trans>,
  <Trans>7. {visitHere}</Trans>,
];

export const attendanceNotes = [
  ...commonNotes,
  ...dateNotes,
  <Trans>4. Time in and Time out must be a valid time in 'HH:MM' format.</Trans>,
];

export const allowanceNotes = [
  ...commonNotes,
];

export const deductionNotes = [
  ...commonNotes,
];
